import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import PageTitle from "../../layouts/PageTitle";
import { selectUserRole } from "../../../store/authSlice";
import EmployeeLedger from "./EmployeeLedger";

const AdminEmployeeImprestPage = () => {
  const navigate = useNavigate();
  const role = useSelector(selectUserRole);
  const { employeeId } = useParams();

  if (role !== "super-admin") {
    return (
      <>
        <PageTitle activeMenu="Employee Imprest" motherMenu="Imprest" />
        <div className="rounded-3xl border border-gray-200 bg-white p-6 text-center text-gray-500 shadow-xl shadow-slate-200/70">
          Only a super-admin can view another employee's imprest ledger.
        </div>
      </>
    );
  }

  return (
    <>
      <PageTitle activeMenu="Employee Imprest" motherMenu="Imprest" />
      <div className="mb-4 flex justify-end">
        <button
          type="button"
          className="rounded-full border-2 border-amber-500 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-gray-700"
          onClick={() => navigate("/imprest/admin")}
        >
          Back to list
        </button>
      </div>
      <EmployeeLedger employeeId={employeeId} canManage />
    </>
  );
};

export default AdminEmployeeImprestPage;
